import { chunk, flatMap, go, map } from 'fxjs/es';
import { MAPLE_CHARACTER_IMAGE_PREPROCESS } from '../../../../Vector/S/Constant/acryl-standizer.constant.ts';
import { CreateMapleAcrylStand } from '../../../../Vector/F/Function/acrylStand/createMapleAcrylStand.ts';
import { DfUtilUi } from '@services/DF/client/util/modal.ts';
import axios from 'axios';
import { SOG_NESS_CHARACTER_FRAME } from '@modules/BpOption/SelectedOptionGroup/S/Constant/selectedoptiongroup.js';

export const makeFrameCharactersWithCutline = async (frame_characters) => {
  const acrylMaker = new CreateMapleAcrylStand();
  return go(
    frame_characters,
    chunk(5),
    flatMap(
      map(async (item) => {
        const { maple_image_url: imageUrl, gc_name: name, avater, nameTag } = item;
        if (avater && nameTag) return item;
        const arr = await acrylMaker.generateWithNameTag(
          [{ name, imageUrl }],
          MAPLE_CHARACTER_IMAGE_PREPROCESS,
        );
        return {
          ...item,
          ...arr[0],
        };
      }),
    ),
  );
};

export const openModalCharacterFrame = async ({ selected_option_group_id, up_id }) => {
  $.don_loader_start();
  const {
    data: { data: selected_option_group },
  } = await axios.get(`/@api/selected_option_group/${selected_option_group_id}`);
  const has_not_frame = selected_option_group._.bp_options.some(
    ({ dev_name }) => dev_name === SOG_NESS_CHARACTER_FRAME.BP_OPTION_NESS_FRAME_NOT_SELECTED,
  );
  const frame_characters_with_cutline = await makeFrameCharactersWithCutline(
    selected_option_group.details.value.frame_characters,
  );
  $.don_loader_end();
  const no_checkbox = false;
  const cardsHtml = frame_characters_with_cutline
    .map(({ avater, gc_name: name }, idx) => {
      const img = avater.image_url;
      const svg = avater.cutline_url;
      return `
      <div style="
        display:inline-block;
        vertical-align:top;
        margin:10px;
        padding:10px;
        border:1px solid #ccc;
        border-radius:8px;
        text-align:center;
        box-shadow:0 2px 5px rgba(0,0,0,0.1);
      ">
        <div style="display:flex; align-items:center; justify-content:center; margin-bottom:5px;">
          <label>
          ${no_checkbox ? '' : `<input type="checkbox" id="chk_${idx}" value="${name}" style="margin-right:5px;">`}
          <div style="display:flex; flex-direction:column; align-items:center;" class="character_box">
            <div style="position:relative; 
        width:400px;
        height:400px; margin-bottom:5px;">
              <img src="${svg}" alt="svg icon" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:contain;">
              <img src="${img}" alt="${name}" style="width:100%; height:100%; object-fit:contain;">
            </div>
            <div style="font-size:14px; color:#333;">${name}</div>
          </div>
</label>
        </div>
      </div>
    `;
    })
    .join('');

  const _html = `
    <div style="width:100%; padding:20px; text-align:center;">
      ${cardsHtml}
      <div style="margin-top:20px;">
        ${
          no_checkbox
            ? ''
            : `<button style="
          padding:8px 16px;
          margin-right:10px;
          background:#f44336;
          border:none;
          border-radius:4px;
          color:#fff;
          cursor:pointer;
        " class="delete_characters">선택된 캐릭터 삭제</button>
        ${
          !has_not_frame
            ? `<button style="
          padding:8px 16px;
          margin-right:10px;
          background:#f44336;
          border:none;
          border-radius:4px;
          color:#fff;
          cursor:pointer;
        " class="delete_frame">액자 삭제</button>`
            : ``
        }`
        }
    </div>
  `;
  function hide(el) {
    el.dispatchEvent(
      new CustomEvent('sl-after-hide', {
        bubbles: true, // 부모로 전파할지 여부
        composed: true, // shadow DOM 밖으로 전파할지 여부
        detail: { foo: 'bar' }, // 필요하면 추가 데이터 전달
      }),
    );
  }
  await DfUtilUi.modal({
    html: _html,
    width: `${window.innerWidth * 0.8}px`,
    label: '네스 선택창 액자',
    appended: (root_el) => {
      const delete_characters_el = root_el.querySelector('.delete_characters');
      delete_characters_el?.addEventListener('click', async () => {
        const inputs = root_el.querySelectorAll('input:checked');
        const names = [...inputs].map((el) => el.value);
        if (await $.confirm(`${names.join(', ')} 를 모두 삭제 합니다.`)) {
          try {
            await axios.delete('/@api/selected_option_group/characters', {
              data: {
                selected_option_group_id,
                up_id,
                names,
              },
            });
            await $.alert('삭제에 성공 했습니다. 환불할 금액이 발생합니다.');
            hide(root_el);
          } catch (e) {
            console.error(e);
            $.alert(e.response?.data);
          }
        }
      });
      const delete_frame_el = root_el.querySelector('.delete_frame');
      delete_frame_el?.addEventListener('click', async () => {
        if (await $.confirm(`액자를 삭제합니다.`)) {
          try {
            await axios.delete('/@api/selected_option_group/characters', {
              data: {
                selected_option_group_id,
                up_id,
                remove_frame: true,
              },
            });
            await $.alert('삭제에 성공 했습니다. 환불할 금액이 발생합니다.');
            hide(root_el);
          } catch (e) {
            console.error(e);
            $.alert(e.response?.data);
          }
        }
      });
    },
  });
};
